/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect } from 'react';
import { Ocupacao } from './styles';

interface OcupationProps {
  atual?: string;
  limite?: string;
  text?: string;
  compareColumn?: string;
  children?: React.ReactNode;
}

const Ocupation: React.FC<OcupationProps> = ({
  atual,
  limite,
  text,
  compareColumn,
  children,
}) => {
  useEffect(() => {
    if (!compareColumn) return; // só faz agrupamento se compareColumn estiver definido

    const table = document.getElementById('box');
    if (!table) return;

    const rows = Array.from(table.getElementsByTagName('tr'));

    let lastCompareValue: string | null = null;
    let masterCell: HTMLTableCellElement | null = null;
    let rowSpanCount = 1;

    rows.forEach((row, rowIndex) => {
      const firstCell = row.cells[0];
      if (!firstCell) return;

      const cellText = firstCell.textContent?.trim() ?? '';

      if (cellText === lastCompareValue) {
        if (masterCell) {
          rowSpanCount += 1;
          masterCell.rowSpan = rowSpanCount;
          firstCell.remove();
        }
      } else {
        lastCompareValue = cellText;
        masterCell = firstCell;
        rowSpanCount = 1;
      }
    });
  }, [compareColumn]);

  return (
    <Ocupacao>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {atual && limite && (
          <div className="ocupacao">
            <p className="atual">{atual}</p>
            <p className="limite">/ {limite}</p>
          </div>
        )}
        {text && <p style={{ fontSize: '16px' }}>{text}</p>}
        {children}
      </div>
    </Ocupacao>
  );
};

export default Ocupation;
